import { Injectable } from '@angular/core';

import { HttpClientService } from '../common/http-client.service';

@Injectable()
export class PaymentObligationService {
  private url: string = 'payment_obligations';

  constructor(private httpClient: HttpClientService) {}

  createPayment(checks: Array<any>): Promise<any> {
    return this.httpClient.post(`${this.url}/create_payment.json`, { checks: checks });
  }

  index(params: any = {}) {
    return this.httpClient.get(`${this.url}.json`, params);
  }

  preparePayment(chart_of_account_ids: Array<number>, payment_obligation_ids: Array<number>): Promise<any> {
    return this.httpClient.post(`${this.url}/prepare_payment.json`, {
      chart_of_account_ids: chart_of_account_ids,
      payment_obligation_ids: payment_obligation_ids,
    });
  }
}
